import axios from 'axios';
import { getDomainOrigin, getAxiosConfig } from 'utils/serverConfig';

export const postOrderDetails = async (
    orderDetails,
    partner: string,
    groupName: string
) => {
    try {
        const { status, data } = await axios({
            method: 'POST',
            url: `${getDomainOrigin()}/api/mpos/partner/${partner}/order?group_name=${groupName}`,
            data: orderDetails,
            ...getAxiosConfig(),
        });
        if (status === 200 && data) {
            return {
                status: true,
                data,
            };
        }
        return {
            status: false,
        };
    } catch (e: any) {
        if (e?.response?.status === 401) {
            return {
                statusCode: 401,
            };
        }
        if (e?.response?.status === 400) {
            return {
                statusCode: 400,
                errorMessage: e?.response?.data?.message,
            };
        }
        if (e?.response?.status === 409) {
            return {
                statusCode: 409,
                errorMessage: e?.response?.data?.message,
            };
        }
        if (e?.response?.status === 410) {
            return {
                statusCode: 410,
                errorMessage: e?.response?.data?.message,
            };
        }
        return {
            status: false,
        };
    }
};

export interface IDocument {
    document_text: string;
    document_helper_text: string;
    id: string;
    mandatory: boolean;
    type: string;

    segment_event: string;
    warning_note?: string;
}

export interface fetchDocumentsResponse {
    statusCode: number;
    data: IDocument[];
    errorMessage?: string;
}

export const fetchDocumentsToBeUploaded = async (
    partnerId: string,
    planId: string,
    programId: string
): Promise<fetchDocumentsResponse> => {
    try {
        const { status, data } = await axios({
            method: 'GET',
            url: `${getDomainOrigin()}/api/mpos/partner/${partnerId}/plan/documents?plan_id=${planId}&program_id=${programId}`,
            ...getAxiosConfig(),
        });

        return {
            statusCode: status,
            data,
        };
    } catch (e: any) {
        if (e?.response?.status === 401) {
            return {
                statusCode: 401,
                data: [],
            };
        }
        if (e?.response?.status === 400) {
            return {
                statusCode: 400,
                errorMessage: e?.response?.data?.message,
                data: [],
            };
        }
        if (e?.response?.status === 409) {
            return {
                statusCode: 409,
                errorMessage: e?.response?.data?.message,
                data: [],
            };
        }
        if (e?.response?.status === 410) {
            return {
                statusCode: 410,
                errorMessage: e?.response?.data?.message,
                data: [],
            };
        }
        return {
            statusCode: 500,
            data: [],
        };
    }
};
